import { Component } from '@angular/core';

@Component({
  selector: 'monorepo-loader-overlay',
  templateUrl: './loader-overlay.component.html',
  styleUrls: ['./loader-overlay.component.scss'],
})
export class LoaderOverlayComponent {}
